<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="flex justify-center m-8">
        <img src="@/assets/images/LogotipoCompleto.png" alt="deltaPOS"/>
      </div>
      <div class="flex justify-center m-8">
        <h2><b>{{ config.title }}</b></h2>
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Acceso a DeltaPOS</h4>
                  <p>Bienvenido, por favor especifique sus credenciales</p>
                </div>

                <div>
                  <vs-input
                    name="userName"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Usuario"
                    v-model="userName"
                    class="w-full"/>

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"/>

                  <div class="flex flex-wrap justify-between my-5">
                    <router-link to="#">¿Olvidó su clave?</router-link>
                  </div>
                  <span>&nbsp;</span>
                  <vs-button class="float-right" @click="login" :disabled="loginDisabled">Acceder</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js');

  export default {
    data() {
      return {
        userName: "",
        password: "",
        loginDisabled: false,
      }
    },
    computed: {
      config() {
        return deltaPOS_config.default;
      }
    },
    methods: {
      getMenu(menu) {
        for (var i = 0; i < menu.length; i++) {
          if (menu[i].options) {
            if (menu[i].options.length > 0) {
              menu[i].submenu = this.getMenu(menu[i].options);
            }
          }
        }
        return menu;
      },
      login() {
        this.loginDisabled = true;
        var self = this;
        var loginData = {
          login: this.userName,
          password: this.password,
          loginDisabled: false
        };
        this.$store.dispatch('updateNavMenuItems', []);
        this.$http.post(this.config.apiURL + '/users/login', loginData).then(response => {
          if (response.data.success) {
            if (response.data.data.token == '') {
              self.$vs.dialog({
                color: 'danger',
                title: 'Error',
                text: 'Acceso denegado'
              })
            } else {
              var userInfo = {
                uid: response.data.data.id,
                userId: response.data.data.id,
                login: response.data.data.login,
                userName: response.data.data.login,
                displayName: response.data.data.name,
                branchId: response.data.data.branchId,
                branchName: response.data.data.branchName,
                branchCode: response.data.data.branchCode,
                branchDB: response.data.data.branchDB,
                token: response.data.data.token
              };
              if (response.data.data.image != "") {
                userInfo.photoURL = response.data.data.image;
              }
              localStorage.setItem(`${self.config.itemPrefix}UserInfo`, JSON.stringify(userInfo));
              localStorage.setItem(`${self.config.itemPrefix}UserId`, response.data.data.id);
              localStorage.setItem(`${self.config.itemPrefix}Login`, response.data.data.login);
              localStorage.setItem(`${self.config.itemPrefix}UserName`, response.data.data.name);
              localStorage.setItem(`${self.config.itemPrefix}Token`, response.data.data.token);
              self.$store.dispatch('updateUserInfo', userInfo);
              self.$store.dispatch('bindStock', userInfo.branchCode);
              self.$http
                .post(deltaPOS_config.default.apiURL + '/users/options', {userId: response.data.data.id, token: response.data.data.token})
                .then(optionsResponse => {
                  if (optionsResponse.data.success) {
                    if (optionsResponse.data.data) {
                      self.$store.dispatch('updateNavMenuItems', self.getMenu(optionsResponse.data.data));
                    }
                    self.$router.push('/');
                  }
                });
            }
          }
          self.loginDisabled = false
        })
      }
    }
  }
</script>

<style lang="scss">
  #page-login {
    .social-login-buttons {
      .bg-facebook {
        background-color: #1551b1
      }

      .bg-twitter {
        background-color: #00aaff
      }

      .bg-google {
        background-color: #4285F4
      }

      .bg-github {
        background-color: #333
      }
    }
  }
</style>
